<!-- 产品类别 -->
<template>
  <BaseFormItem2
    class="board_type"
    :label="fields.label"
    :labelTips="fields.labelTips"
  >
    <BaseRadioGroup2 v-model="val" @change="handleEmit">
      <el-radio-button
        class="board_type__radio"
        v-for="item in fields.options"
        :key="item.value"
        :label="item.value"
        @click.native.prevent="handleItemClick(item.value)"
      >
        {{ item.label }}
        <img 
          v-if="item.value == 'CEM-1'"
          class="board_type__radio__new" 
          :src="require('@@/assets/img/icons/icon_new.png')" 
        />
      </el-radio-button>
    </BaseRadioGroup2>
  </BaseFormItem2>
</template>

<script>
import { getFR4Fields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: String,
      default: 'FR-4'
    },
  },
  data() {
    return {
      val: this.value
    }
  },
  computed: {
    fields() {
      return getFR4Fields('board_type')
    },
  },
  watch: {
    value(newVal) {
      // this.val = newVal
      this.handleItemClick(newVal)
    },
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.$emit('change', val)
    },
    handleItemClick(board_type) {
      if (['CEM-1', 'CEM-3', 'FR-1', '22F', 'FPC'].includes(board_type)) {
        const path = board_type === 'FPC' ? '/quote_new/fpc/' : `/quote_new?board_type=${board_type}`
        // 新窗口打开
        window.open(path)
      } else {
        this.val = board_type
        this.handleEmit()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.board_type__radio {
  position: relative;
  .board_type__radio__new {
    position: absolute;
    top: -10px;
    right: 6px;
  }
}
</style>